import { ASSIGNMENT_FEATURE_KEY } from '../reducers';
import { AssignmentState } from '../types';

export const getAssignmentState = (state: {
  [ASSIGNMENT_FEATURE_KEY]: AssignmentState;
}) => state[ASSIGNMENT_FEATURE_KEY];

export const getCurrentAssignment = (state: {
  [ASSIGNMENT_FEATURE_KEY]: AssignmentState;
}) => state[ASSIGNMENT_FEATURE_KEY].currentAssignment;

export const getCurrentAssignmentForm = (state: {
  [ASSIGNMENT_FEATURE_KEY]: AssignmentState;
}) => state[ASSIGNMENT_FEATURE_KEY].currentForm;

export const getSearchResults = (state: {
  [ASSIGNMENT_FEATURE_KEY]: AssignmentState;
}) => state[ASSIGNMENT_FEATURE_KEY].searchResults;

export const getSearchResultsError = (state: {
  [ASSIGNMENT_FEATURE_KEY]: AssignmentState;
}) => state[ASSIGNMENT_FEATURE_KEY].error;
